exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social-media-plan-popup .field-box[data-v-99bbfaea] {\n  margin-top: 16px;\n}\n.social-media-plan-popup[data-v-99bbfaea] {\n  margin-left: 0px;\n}\n", ""]);

// exports
